import { defineMessages } from 'react-intl'

const scope = `procurify.components.CurrencyConversionInfo`

export default defineMessages({
  exchangeRateLabel: {
    id: `${scope}.exchangeRateLabel`,
    defaultMessage: 'Exchange Rate',
  },
})
